/* Eager UI messages (en): merged from several small families that serve eager scripts. Norwegian is the source of truth. */
// private-onboarding-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'pob.personal': 'Personal finance',
  'pob.step1Eyebrow': 'Step 1 · Use',
  'pob.step1Title': 'What do you want to use Plumme for?',
  'pob.step1Lead': 'Choose personal finance, family finance or both. Family can be switched on and off later from My page.',
  'pob.personalDesc': 'Overview, spending, savings, loans, tax and reports for you.',
  'pob.family': 'Family finance',
  'pob.familyDesc': 'Shared budget and cost split in the household without sharing private transactions.',
  'pob.step2Eyebrow': 'Step 2 · Data and privacy',
  'pob.step2Title': 'You decide what Plumme gets to see',
  'pob.familyLinkNote': 'A family link only shares information you register on the Family page. Accounts, transactions, tax and other plans stay private.',
  'pob.readyEyebrow': 'Ready to start',
  'pob.readyLead': 'Welcome as a Plumme user. If you start a business one day, Plumme is ready to take care of the bookkeeping when you need it.',
  'pob.inviteNote': 'When you continue, Personal finance is created and the family invitation is accepted.',
});
// assistant-control-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'acm.noAdapter': 'The assistant action has no approved adapter.',
  'acm.invoiceDraftFailed': 'The invoice draft could not be created.',
  'acm.paymentFailed': 'The payment could not be registered.',
  'acm.customerSaveFailed': 'The customer could not be saved.',
  'acm.supplierSaveFailed': 'The supplier could not be saved.',
  'acm.productSaveFailed': 'The product could not be saved.',
});
// app-shell-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'shm.myBusinesses': 'My businesses',
  'shm.clientAssignments': 'Client assignments',
  'shm.pdfLoading': 'Loading preview…',
  'shm.pdfDownloadNamed': 'Download {name}',
  'shm.pdfPage': 'Page',
});
// business-invite-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'biv.role.owner': 'Owner',
  'biv.role.accountant': 'Accountant',
  'biv.role.admin': 'Administrator',
  'biv.role.viewer': 'Read access',
  'biv.role.fallback': 'Access',
  'biv.toast.nowOwner': 'You are now the owner of {name}.',
  'biv.toast.gotAccess': 'You now have access to {name}.',
  'biv.toast.acceptFailed': 'Could not accept the invitation.',
  'biv.toast.stillNotVerified': 'The address is still not verified. Check your inbox and spam folder.',
  'biv.toast.declined': 'The invitation has been declined.',
  'biv.toast.declineFailed': 'Could not decline the invitation.',
  'biv.clientInvitation': 'Client invitation',
  'biv.signInWithInviteEmail': 'Sign in with the email address from the invitation',
  'biv.noActiveInvite': 'This link is saved, but we cannot find an active client invitation for {email}.',
  'biv.thisAccount': 'this account',
  'biv.signOutAndIn': 'Sign out and back in with the email address the invitation was sent to. Then Plumme can show the client and accept the access without you creating a new business.',
  'biv.later': 'Later',
  'biv.accountantSetup': 'Accountant setup',
  'biv.workWithClients': 'Work with clients in Plumme',
  'biv.firmIntro': 'If you work at an accounting firm, you create the firm here and invite your colleagues. The firm workspace is not a separate login — it lives in the same app, with a client overview, reconciliation and team chat.',
  'biv.soloIntro': 'If you work alone with individual clients, you can instead start setting up a client business. Until controlled ownership transfer is in place, you are registered as the owner of the business you create.',
  'biv.createClientBusiness': 'Create client business',
  'biv.ownershipChange': 'Change of ownership',
  'biv.accountantClientAccess': 'Accountant · Client access',
  'biv.takeOver': 'Take over {name}',
  'biv.invitedTo': 'You are invited to {name}',
  'biv.leadOwnership': 'When you accept, you become the owner of the business in Plumme. Use the same email address the invitation was sent to.',
  'biv.leadRole': 'The invitation gives the role {role} in this business. The same login can also be used for your own businesses, Personal finance and the Employee portal.',
  'biv.step1': 'Step 1 · Access',
  'biv.whatRoleCanDo': 'What the role can do',
  'biv.canWork': 'View and work with the accounts, vouchers, bank reconciliation, reports and filings for the client.',
  'biv.cannotMoveOwner': 'This moves the owner role to you. The previous owner gets the access that was chosen when the invitation was sent.',
  'biv.cannotOwn': 'Cannot take over ownership, delete the business or manage other users. The owner or an administrator controls access.',
  'biv.dataSeparate': 'The client\'s data is kept separate from your own businesses, Personal finance and any employers.',
  'biv.step2': 'Step 2 · Ready',
  'biv.readyOwnership': 'When you accept, the business opens as your business. The change of ownership is logged with time and users.',
  'biv.readyAccess': 'When you accept, the business is added under Client assignments and opens directly. You can switch context from the client selector at any time.',
  'biv.expired': 'The invitation has expired. Ask the sender to send it again.',
  'biv.verifyEmail': 'Verify your email address before the invitation can be accepted. We have sent a link to {email}. Open it, and press "I have verified".',
  'biv.yourAddress': 'your address',
  'biv.accountantInvitation': 'Accountant invitation',
  'biv.back': '← Back',
  'biv.checking': 'Checking...',
  'biv.iHaveVerified': 'I have verified',
  'biv.accepting': 'Accepting...',
  'biv.acceptAndOpen': 'Accept and open the client',
  'biv.pendingTitle': 'Client invitation pending',
  'biv.pendingText': 'Sign in with the email address the invitation was sent to in order to accept the access.',
  'biv.viewInvitation': 'View invitation',
  'biv.expiredOwnership': 'Expired change of ownership',
  'biv.expiredInvitation': 'Expired client invitation',
  'biv.newOwnership': 'New change of ownership',
  'biv.newInvitation': 'New client invitation',
  'biv.askSenderResend': 'Ask the sender to resend',
  'biv.viewAccess': 'View access',
});
// backend-actions-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'bam.inv.pickFromTo': 'Select both a from and a to account.',
  'bam.inv.sameAccount': 'The from and to accounts cannot be the same account.',
  'bam.inv.vatCodeNotAllowed': 'Account {code} cannot have a VAT code in a free-form entry.',
  'bam.inv.describeAllPostings': 'Enter a description on all entries before you post.',
  'bam.inv.validDate': 'Select a valid date.',
  'bam.inv.receiptFailed': 'Could not create the receipt.',
  'bam.inv.lostOnlyPostedPurchases': 'Voucher missing can only be marked on posted purchases.',
  'bam.inv.noActivePurchaseWithoutVoucher': 'Could not find an active purchase without a voucher.',
  'bam.inv.missingOffsetDocs': 'Invoice or credit note is missing for the offset.',
  'bam.inv.missingOffsetToReverse': 'The invoice or offset to be reversed is missing.',
  'bam.inv.missingRefundInvoice': 'Invoice is missing for the refund.',
  'bam.inv.missingAllocationInvoices': 'Source or target invoice is missing for the allocation.',
  'bam.inv.missingAllocationToReverse': 'The invoice or allocation to be reversed is missing.',
  'bam.inv.settleNeedsFreePosting': 'Settlement without payment requires an active free-form entry.',
  'bam.inv.missingSupplierInvoiceSettle': 'Supplier invoice is missing for the settlement.',
  'bam.inv.supplierInvoiceNotFound': 'The supplier invoice was not found.',
  'bam.inv.supplierInvoiceNothingRemaining': 'The supplier invoice has no remaining amount.',
  'bam.inv.freePostingNoMatchingAmount': 'The free-form entry has no unused, matching amount on debit 2400.',
  'bam.inv.missingSupplierInvoiceOverpayment': 'Supplier invoice is missing for the overpayment.',
  'bam.inv.missingFreePostingToLink': 'The free-form entry to be linked is missing.',
  'bam.inv.settleMustLinkFreePosting': 'Settlement without payment must be linked to a free-form entry.',
  'bam.inv.sentAsLink': 'The invoice was sent as a link.',
  'bam.inv.sentByEmail': 'The invoice was sent by email.',
  'bam.inv.receiptSentByEmail': 'The receipt was sent by email.',
  'bam.inv.stepFailed': 'The step failed.',
  'bam.bank.missingMatchGroup': 'Match group is missing.',
  'bam.bank.screenshotReadFailed': 'Could not read the screenshot.',
  'bam.bank.screenshotFormat': 'Use a screenshot in PNG, JPEG or WebP format.',
  'bam.bank.screenshotTooLarge': 'The screenshot must be smaller than 8 MB.',
  'bam.bank.screenshotTimeout': 'Reading the screenshot took too long. Try again or upload the original file.',
  'bam.bank.openingSetupMissing': 'The bank account is missing a start date or opening balance. Fill in both in the bank settings; enter 0 if the balance was zero.',
  'bam.bank.ledgerMismatch': 'The bank reconciliation differs from the general ledger or has entries before the opening balance. Check the balance and entries before the period is finalised.',
  'bam.bank.missingStatement': 'Bank statement is missing.',
  'bam.billing.supplierNumberInUse': 'Supplier number {number} is already in use.',
  'bam.billing.incomeAccountFormat': 'An income account must start with 3 and have 4 or 5 digits.',
  'bam.billing.incomeAccountName': 'Give the new income account a name.',
  'bam.billing.incomeAccountStandard': 'Select which standard income account the account corresponds to.',
  'bam.billing.accountExists': 'Account {code} already exists.',
  'bam.billing.missingTextLine': 'Text line is missing.',
  'bam.billing.textLineNotFound': 'The text line does not exist.',
  'bam.recon.internalTransfers': 'Internal transfers are corrected by reversing the whole match group.',
  'bam.recon.purchaseNotFound': 'Could not find the purchase to be corrected.',
  'bam.recon.pickVoucher': 'Select a voucher before you link it to the entry.',
  'bam.recon.originalEntryNotFound': 'Could not find the original posted entry behind the voucher.',
  'bam.recon.cannotLinkSafely': 'The bank line cannot be linked safely to the posted entry.',
  'bam.recon.notLinked': 'The bank line is not linked to an existing entry.',
  'bam.recon.loanSumMismatch': 'Instalments, interest and fees must add up to the bank amount.',
  'bam.recon.loanSplitUnbalanced': 'The loan/debt split does not balance. Use a free-form entry for this bank line.',
  'bam.registry.noFirebaseDailyAdvice': 'Firebase is not configured, so today\'s advice is not available.',
  'bam.registry.needLoginDailyAdvice': 'You must be signed in to fetch today\'s advice.',
  'bam.settingsData.excelImportUnavailable': 'Excel import is not available yet.',
  'bam.settingsData.excelExportUnavailable': 'Excel export is not available yet.',
  'bam.settingsData.pickSaftXml': 'Select a SAF-T XML file.',
  'bam.settingsData.saftNorwayOnly': 'SAF-T export is only available for Norwegian companies.',
  'bam.settingsData.saftNeedsOrgNumber': 'SAF-T requires a valid organisation number (9 digits) in settings.',
  'bam.settingsData.saft140': 'SAF-T 1.40 must be implemented before exporting fiscal years from 2027.',
  'bam.registry.lookupFailed': 'Lookup failed.',
  'bam.registry.brregLookupFailed': 'BRREG lookup failed.',
  'bam.registry.brregSearchFailed': 'BRREG search failed.',
  'bam.registry.addressLookupFailed': 'Address lookup failed.',
});
// misc-eager-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1e.app.viewClientInvite': 'View client invitation',
  'r1e.app.createPersonal': 'Create Personal finance',
  'r1e.app.imAccountant': 'I am an accountant',
  'r1e.acc.createViaBackend': 'Account creation is handled by the Plumme backend.',
  'r1e.acc.resetFollowLink': '. Follow the link in the email to create a new password.',
  'r1e.household.title': 'Family finance invitation',
  'r1e.household.defaultInviter': 'A Plumme user',
  'r1e.household.body': '{inviter} wants to connect the Family page with you. Individual accounts and transactions are not shared.',
  'r1e.spec.schemeSaved': 'Tax and duty scheme saved',
  'r1e.spec.schemeRemoved': 'Scheme removed',
  'r1e.spec.addedBody': 'The specification has been added to the tax return. Fill in the items that apply to {company}.',
  'r1e.pub.opening': 'Opening document...',
  'r1e.pub.loading': 'Loading the document...',
  'r1e.pub.quantity': 'Quantity',
  'r1e.pub.pdfTitle': 'Document PDF',
  'r1e.pub.offerMissingData': 'The quote is missing acceptance data. Ask the sender to send the link again.',
  'r1e.pub.offerAlreadyAccepted': 'The quote had already been accepted.',
  'r1e.pub.offerAccepted': 'Thank you, the quote has been accepted.',
  'r1e.pub.offerAcceptFailed': 'Could not accept the quote.',
  'r1e.budget.codeFormat': 'The account number must have 4 or 5 digits and start with 1-8.',
  'r1e.budget.nameRequired': 'Give the new account a name.',
  'r1e.budget.pickStandard': 'Select which standard account the account corresponds to.',
  'r1e.budget.accountExists': 'Account {code} already exists.',
  'r1e.budget.standardMissing': 'Standard account {code} does not exist.',
  'r1e.booking.bankAccountMissing': 'The bank account has no ledger account in the books. Select a general ledger account before posting.',
  'r1e.booking.pickExpenseAccount': 'Select an expense account before the bank line is posted.',
  'r1e.booking.invoiceNumberRequired': 'Enter an invoice number before the supplier invoice is posted.',
  'r1e.booking.payrollTaxFlow': 'From 2026, withholding tax and employer\'s contribution must first be registered under Payroll. Then match the bank line against the existing payment voucher.',
  'r1e.bookingHelpers.taxPaymentNoOnly': 'Automatic posting of tax payments from the bank is currently only supported for Norwegian companies.',
  'r1e.bookingHelpers.taxPaymentManualReview': 'The tax payment requires manual review of the company form and settlement account before posting.',
  'r1e.lines.patternIdMissing': 'The pattern is missing an identifier.',
  'r1e.lines.correctionReasonRequired': 'Briefly state why the bank line is being corrected.',
  'r1e.lines.alreadyLinked': 'The bank line is already linked or posted. Open the link/posting before the reading is corrected.',
  'r1e.purchaseEditor.vatLocked': 'The VAT period has been submitted. You can only change the description and expense account/category on this purchase. Open or correct the VAT period before changing the purchase date, amount, VAT code or payment.',
  'r1e.purchaseEditor.descriptionRequired': 'Enter a description on all lines before you post.',
  'r1e.state.readOnlyDemo': 'This business is read-only because it points to demo data for another user.',
  'r1e.state.changedInOtherTab': 'Business data was changed in another tab. Reload the page before saving again.',
  'r1e.autopilot.taskMissing': 'Task is missing.',
  'r1e.access.memberMissing': 'The user to remove is missing.',
  'r1e.recon.businessOrPeriodMissing': 'The business or period for the document is missing.',
  'r1e.vehicle.policyLoadFailed': 'The vehicle setting could not be loaded.',
  'r1e.annual.yearEndRequired': 'Year-end closing for {year} must be completed before the annual accounts can be changed.',
  'r1e.vehiclePolicy.pickDateAndMode': 'Select a valid date and vehicle setting.',
  'r1e.vehiclePolicy.confirmResponsibility': 'You must confirm that the business keeps this information up to date itself.',
  'r1e.zip.unknownContent': 'Unknown file content in the zip archive.',
  'r1e.zip.noFiles': 'No files to pack.',
  'r1e.reconFinish.unavailable': 'Reconciliation is not available yet.',
  'r1e.reconFinish.statementMissing': 'Bank statement is missing.',
});
